import {
  Component, OnInit, ViewChild, AfterViewInit, OnDestroy, ElementRef,
} from '@angular/core';
import { DialogsService } from '@services/dialogs-service';
import {PreciosService, PIZARRA_COLUMNS, BreakpointsObserverService, ResponsiveService, Breakpoints} from '@services/index';
import { Observable } from 'rxjs/Observable';
import * as moment from 'moment';
import {parseDate, dateToUnixTime, DateTimePipe, PricePipe} from '@utils/index';
import { SpinnerService } from '@services/spinner-service';
import { ABMRolesService } from '@services/abm-roles-service';
import {PrecioMonitor} from '@common/precio-monitor';
import {compare, getProductoScore} from '../precios/precios.component';
import {PrecioGenericViewModel} from '@utils/ViewModels';
import {FormSelectItem, FormSelectMultipleItem} from '@common/form-components';
import {AbstractControl, FormBuilder, FormGroup} from '@angular/forms';
import {Subscription} from 'rxjs/Subscription';
import {Subject} from 'rxjs/Subject';

@Component({
  selector: 'app-precios-pizarra',
  templateUrl: './precios-pizarra.component.html',
  styleUrls: ['./precios-pizarra.component.scss', '../precios-common-styles.scss']
})
export class PreciosPizarraComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('dateFilterPicker') dateFilterPicker;
  @ViewChild('quickFilters') quickFilters: ElementRef;

  monitorKey = 'grid';
  grillaKey = 'list'
  viewMode: string = this.monitorKey;

  // private columns = ['cotización', 'publicación', 'soja', 'maiz', 'trigo', 'girasol', 'sorgo', 'responsable', 'validador'];

  public columns = PIZARRA_COLUMNS;
  public columnsLength = Object.keys(this.columns).length;

  // Columnas que necesitan filtro price
  public needPriceFilter = { Soja: true, Maiz: true, Trigo: true, Sorgo: true, Girasol: true};

  showQuickFilters = false;

  filters = {};
  chips = [];

  private productoOptions = [];

  private sortTimeout;

  // Columna de sorting elegida actualmente
  sortColumn: string = this.columns.PUBLICACION;
  sortOrder = 0;

  // Columnas con tipo de dato desde/hasta en números
  private fromToColumns = [
    this.columns.SOJA.toLowerCase(),
    this.columns.MAIZ.toLowerCase(),
    this.columns.TRIGO.toLowerCase(),
    this.columns.GIRASOL.toLowerCase(),
    this.columns.SORGO.toLowerCase()
  ];
  // Columnas con tipo de dato autocompletar
  private arrayColumns = [this.columns.RESPONSABLE.toLowerCase(), this.columns.VALIDADOR.toLowerCase()];

  // Grid
  private products = [];
  prices = [];

  private precios = [];
  private preciosMonitorRaw = [];
  monitorGenericoPrecios: PrecioMonitor[] = []

  mercadoKey = 'merc';
  productoKey = 'prod';
  monedaKey = 'mon';
  publicacionKey = 'publ';

  altProdOrder = false; // toggle para ordenar productos alfabeticamente

  private verticalScroll: any;
  private scrollSubscriber: any;
  private precioPage: number = 0;
  private loadingPrices: boolean;
  private allPricesLoaded: boolean;

  filterMercado: FormSelectMultipleItem[] = [];
  mercados: FormSelectItem[] = [];

  monitorForm: FormGroup;

  // hacemos un objeto pues las opciones son dinamicas
  ordenarAgruparRawOptions = {
    mercado: {Label: 'Mercado', Id: this.mercadoKey},
    producto: {Label: 'Producto', Id: this.productoKey},
    moneda: {Label: 'Moneda', Id: this.monedaKey},
    publicacion: {Label: 'Hora de publicación', Id: this.publicacionKey},
  };

  agruparOptions: FormSelectItem[] = [this.ordenarAgruparRawOptions.mercado, this.ordenarAgruparRawOptions.producto];
  ordenarOptions: FormSelectItem[] = [
    this.ordenarAgruparRawOptions.producto,
    this.ordenarAgruparRawOptions.moneda,
    this.ordenarAgruparRawOptions.publicacion,
  ];

  grillaForm: FormGroup;

  subscriptionTsunami: Subscription[] = [];
  destroySubject = new Subject<void>();
  isMobile = false;
  constructor(
    private spinnerService: SpinnerService,
    private dialogsService: DialogsService,
    private preciosService: PreciosService,
    private rolesService: ABMRolesService,
    private dateTimePipe: DateTimePipe,
    private pricePipe: PricePipe,
    private fb: FormBuilder,
    private breakpointsService: BreakpointsObserverService,
    private responsiveService: ResponsiveService
  ) {
    breakpointsService.observe([Breakpoints.XSmall, Breakpoints.Small])
      .map(x => x.matches)
      .takeUntil(this.destroySubject)
      .subscribe(x => {
        this.isMobile = x;
      });

    rolesService.getProductos().subscribe(newValue => {
      this.productoOptions = newValue;
    });
    preciosService.checkNewPricesForReview();
    preciosService.getMercadosPizarra().take(1).subscribe(x => {
      this.mercados = x.filter(y => y.Visibilidad).map(x => ({Id: x.Id, Label: x.Mercado}));
    });

    this.monitorForm = fb.group({
      agrupar: this.ordenarAgruparRawOptions.mercado,
      agruparDirection: true,
      ordenar: this.ordenarAgruparRawOptions.producto,
      ordenarDirection: true,
      mercados: [[]],
    });

    this.grillaForm = fb.group({
      fecha: moment().toDate()
    });

    this.subscriptionTsunami.push(
      this.monitorForm.get('agrupar').valueChanges.subscribe(x => {
        this.orderPreciosMonitor(true);
      }),

      this.monitorForm.get('ordenar').valueChanges.subscribe(x => {
        this.orderPreciosMonitor(true);
      }),
    );

  }

  ngOnInit() {

  }

  toggleFilters(e) {
    if (e.srcElement.id === 'monitorFilterClick' || e.srcElement.id === 'grillaFilterClick') {
      this.showQuickFilters = !this.showQuickFilters;
    }
  }

  applyFilters() {
    if (this.viewMode === 'list') {
      this.resetGrillaPrecios();
      this.getGrillaPrecios();
    } else {
      this.getMonitorPrecios();
    }
    this.showQuickFilters = false;
  }

  getColumnOrder(): any {
    const isProduct = this.productoOptions.find(x => x.Producto.toLowerCase() === this.sortColumn.toLowerCase());
    if (isProduct) {
      return {
        ColumnName: 'Producto',
        ProductoId: isProduct.Id
      };
    }
    return {
      ColumnName: this.sortColumn,
      ProductoId: 0
    };
  }

  getGrillaPrecios(): void {
    if (this.allPricesLoaded) return;
    this.spinnerService.setShowFlag(true);
    const gridFilters: any = this.filters;
    let idUsuarios: Array<number>;
    let idValidadores: Array<number>;
    const productFilter: any = [];
    if (gridFilters.responsable) {
      idUsuarios = gridFilters.responsable.map(x => {
        return x.UserId;
      });
    }
    if (gridFilters.validador) {
      idValidadores = gridFilters.validador.map(x => {
        return x.UserId;
      });
    }

    this.productoOptions.forEach(po => {
      if (gridFilters[po.Producto.toLowerCase()]) {
        const prodFilter = gridFilters[po.Producto.toLowerCase()];
        productFilter.push({
          ProductId: po.Id,
          DecimalRange: {
            MinValue: prodFilter.model1,
            MaxValue: prodFilter.model2
          }
        });
      }
    });

    // fecha de publicacion
    let publicacionFromDate = 0;
    let publicacionToDate = 0;

    let cotizacionFromDate = 0;
    let cotizacionToDate = 0;

    if (gridFilters.fecha) {
      publicacionFromDate = dateToUnixTime(moment(gridFilters.fecha.startDate).startOf('day').toDate());
      publicacionToDate = dateToUnixTime(moment(gridFilters.fecha.endDate).endOf('day').toDate());
    } else {
      // Si no se seleccionó rango de fechas de publicacion, se tiene que usar el filtro de fecha de publicacion
      let fechaCtrl = this.grillaForm.get('fecha');
      let fechaValue = fechaCtrl.value as Date;
      publicacionFromDate = dateToUnixTime(moment(fechaValue).startOf('day').toDate())
      publicacionToDate = dateToUnixTime(moment(fechaValue).endOf('day').toDate());
    }

    if (gridFilters['cotización']) {
      cotizacionFromDate = dateToUnixTime(moment(gridFilters['cotización'].startDate).startOf('day').toDate());
      cotizacionToDate = dateToUnixTime(moment(gridFilters['cotización'].endDate).endOf('day').toDate());
    }

    this.loadingPrices = true;
    const columnOrder = this.getColumnOrder();

    this.preciosService.getPizarraGrilla(
      this.precioPage,
      columnOrder.ColumnName,
      this.sortOrder === 0,
      columnOrder.ProductoId,
      publicacionFromDate,
      publicacionToDate,
      idUsuarios,
      productFilter,
      idValidadores,
      cotizacionFromDate,
      cotizacionToDate,
      gridFilters.mercado ? gridFilters.mercado.model1 : 0)
      .subscribe(res => {
        if (res) {
          res.forEach(r => {
            const price = {
              MERCADO: r.Mercado.Mercado,
              COTIZACION: this.dateTimePipe.transform(parseDate(r.Fecha), 'dd/mm/yyyy'),
              PUBLICACION: this.dateTimePipe.transform(parseDate(r.FechaPublicacion), 'dd/mm/yyyy hh:mm'),
              VALIDADOR: r.UsuarioValidador ? r.UsuarioValidador.UserFullName : '-',
              RESPONSABLE: r.UsuarioCreador.UserFullName,
            };
            const propertyName = r.Producto.Producto.toString().toUpperCase();
            price[propertyName] = r.Precio;
            this.prices.push(price);
          });
          this.allPricesLoaded = res.length === this.prices.length;
          this.precioPage++;
        }
        this.loadingPrices = false;
        this.spinnerService.setShowFlag(false);
      }, err => this.spinnerService.setShowFlag(false));
  }

  getMonitorPrecios(): void {
    this.spinnerService.setShowFlag(true);

    this.preciosService.getPizarraMonitor(this.monitorForm.get('mercados').value.map(x => x.Id))
      .subscribe(res => {
        if (res) {
          this.preciosMonitorRaw = res;
          this.orderPreciosMonitor();
        }
        this.spinnerService.setShowFlag(false);
      }, err => this.spinnerService.setShowFlag(false));

  }

  ngAfterViewInit() {
    // CUSTOM VERTICAL SCROLL CON STICKY HEADER
    this.verticalScroll = window.document.querySelector('.mat-drawer-content');

    // INFINITE SCROLL
    this.scrollSubscriber = Observable.fromEvent(this.verticalScroll, 'scroll')
      .debounceTime(300)
      .map(() => this.verticalScroll.scrollTop)
      .subscribe(x => {
        if (this.viewMode !== 'list' || this.loadingPrices || this.allPricesLoaded) {return; }
        const max = this.verticalScroll.scrollHeight - this.verticalScroll.clientHeight;
        if (x > max * 0.7) {
          this.getGrillaPrecios();
        }
      });

    this.getMonitorPrecios();
  }

  viewPriceDetail(price, producto) {
    this.dialogsService.showPrecioDetailDialog(price.user, price.date, price.validador, true, price.publicacionDate, producto, price.mercado.Mercado);
  }

  changeViewMode(mode) {
    this.viewMode = mode;

    // Al cambiar a la grilla por primera vez en la sesión cargar el listado
    if (this.viewMode === 'list' && !this.allPricesLoaded && !this.prices.length) {
      this.getGrillaPrecios();
    }
  }

  openFilterModal(column) {
    clearTimeout(this.sortTimeout);
    this.dialogsService.showPreciosFilterDialog(column.toLowerCase(), column, this.filters)
      .subscribe((res: any) => {
        if (res) {
          this.filters = res.filters;

          // Si elegimos Guardar pero no cargamos ninguna info en este filtro, lo quitamos
          if (this.fromToColumns.indexOf(column) >= 0) {
            if (typeof this.filters[column].model1 !== 'number' && typeof this.filters[column].model2 !== 'number') {
              delete this.filters[column];
            }
          } else if (this.arrayColumns.indexOf(column) >= 0) {
            if (!this.filters[column] || this.filters[column].length === 0) {
              delete this.filters[column];
            }
          }
        }

        this.buildChips();

        this.resetGrillaPrecios();
        this.getGrillaPrecios();
      });
  }

  buildChips() {
    this.chips = Object.keys(this.filters).map(key => {
      let value = '';
      switch (key) {
        case 'fecha':
        case this.columns.COTIZACION.toLowerCase():
          value = moment(this.filters[key].startDate).format('DD-MM-YY') + ' al ' + moment(this.filters[key].endDate).format('DD-MM-YY');
          break;
        case this.columns.RESPONSABLE.toLowerCase():
          if (this.filters[this.columns.RESPONSABLE.toLowerCase()].length === 1) {
            value = this.filters[this.columns.RESPONSABLE.toLowerCase()][0].UserFullName;
          } else {
            value = 'Varios';
          }
          break;
        case this.columns.VALIDADOR.toLowerCase():
          if (this.filters[this.columns.VALIDADOR.toLowerCase()].length === 1) {
            value = this.filters[this.columns.VALIDADOR.toLowerCase()][0].UserFullName;
          } else {
            value = 'Varios';
          }
          break;
        case this.columns.SOJA.toLowerCase():
        case this.columns.MAIZ.toLowerCase():
        case this.columns.TRIGO.toLowerCase():
        case this.columns.SORGO.toLowerCase():
        case this.columns.GIRASOL.toLowerCase():
          value = this.filters[key].model1 + '-' + this.filters[key].model2;
          break;
        case this.columns.MERCADO.toLowerCase():
          value = this.filters[key].model1Value;
          break;
      }

      return {
        col: key,
        title: this.getChipTitle(key),
        value: value
      };
    });
  }

  getChipTitle(col) {
    if (col === 'fecha') {
      return this.columns.PUBLICACION;
    } else if (col === 'filterProductos') {
      return 'Producto';
    } else {
      return this.getFirstUpperCase(col);
    }
  }

  resetGrillaPrecios() {
    this.precioPage = 0;
    this.allPricesLoaded = false;
    this.prices = [];
  }

  sortByColumn(column, immediate) {
    clearTimeout(this.sortTimeout);
    this.sortTimeout = setTimeout(() => {
      if (this.sortColumn === this.columns[column]) {
        this.sortOrder = (this.sortOrder + 1) % 2;
      } else {
        this.sortColumn = this.columns[column];
        this.sortOrder = 0;
      }
      this.resetGrillaPrecios();
      this.getGrillaPrecios();
    }, immediate ? 0 : 250);
  }

  getColumnTitle(col) {
    return col.charAt(0).toUpperCase() + col.slice(1);
  }

  removeFilter(chip) {
    this.chips = this.chips.filter(c => c.col !== chip.col);

    delete this.filters[chip.col];

    if (this.viewMode === 'list') {
      this.resetGrillaPrecios();
      this.getGrillaPrecios();
    }
  }

  showDateFilterPicker() {
    this.dateFilterPicker.open();
  }

  ngOnDestroy(): void {
    if (this.scrollSubscriber) {
      this.scrollSubscriber.unsubscribe();
    }
    this.subscriptionTsunami.forEach(x => x.unsubscribe());
    this.destroySubject.next()
  }

  resetFilters() {
    if (this.viewMode === 'list') {
      this.filters = {};
      this.chips = [];
      this.sortColumn = 'Cotización';
      this.grillaForm.get('fecha').setValue(moment().toDate());
    } else {
      this.monitorForm.get('mercados').setValue([]);
    }
    this.applyFilters();
  }

  getFirstUpperCase(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  orderPreciosMonitor(resetAlt = false) {

    if (this.monitorGroup.value.Id === this.mercadoKey) {
      this.ordenarOptions = [
        this.ordenarAgruparRawOptions.producto,
        this.ordenarAgruparRawOptions.moneda,
        this.ordenarAgruparRawOptions.publicacion,
      ];
    } else {
      this.ordenarOptions = [
        this.ordenarAgruparRawOptions.mercado,
        this.ordenarAgruparRawOptions.moneda,
        this.ordenarAgruparRawOptions.publicacion,
      ];
    }

    if (this.monitorGroup.value.Id === this.monitorOrder.value.Id) {
      this.monitorOrder.setValue(this.monitorGroup.value.Id === this.mercadoKey ?
        this.ordenarAgruparRawOptions.producto :
        this.ordenarAgruparRawOptions.mercado,
        {emitEvent: false}
      );
    }

    if (resetAlt) {
      this.altProdOrder = false;
    }

    if (this.preciosMonitorRaw.length) {
      const precios = this.preciosMonitorRaw.map(x => {
        return {
          Fecha: moment.unix(x.FechaPublicacion).format('HH:mm') + ' hs.',
          Grupo: this.monitorGroup.value.Id === this.mercadoKey ? x.Mercado.Mercado : x.Producto.Producto,
          Superior: this.monitorGroup.value.Id === this.mercadoKey ? x.Producto.Producto : x.Mercado.Mercado,
          Inferior: '', // inferior se usa para mostrar posiciones, no lo necesitamos
          Moneda: x.Moneda.Simbolo,
          Precio: this.pricePipe.transform(x.Precio, 'fill'),
          Varianza: x.Varianza !== null ? x.Varianza : 0,
          PrecioRAW: this.parsePizarraGenericPrecio(x),
          FechaRaw: x.FechaPublicacion,
        } as PrecioMonitor;
      });

      precios.sort((a, b) => {
        // Paso 1: Ordenar los Grupos
        if (a.Grupo !== b.Grupo) {
          if (this.monitorGroup.value.Id === this.productoKey) {
            return this.altProdOrder ?
              // alternativo, alfabeticamente
              compare(a.Grupo, b.Grupo, this.monitorGroupDirection.value) :
              // normal, por score de producto
              compare(getProductoScore(a.Grupo), getProductoScore(b.Grupo), this.monitorGroupDirection.value)
          } else {
            return compare(a.Grupo, b.Grupo, this.monitorGroupDirection.value)
          }
        }

        // Paso 2: Ordenar en cada grupo el subgrupo, ya sea producto o mercado.
        // Por cada producto o mercado se debe producir un salto de linea. Dicho salto se define más abajo.

        // tenemos en cuenta el grupo, si es producto, ordenamos por mercado internamente y viceversa para producto
        // esto es asi dado que ahora producto y mercado, internamente son un subgrupo, por lo que se quitan de la lista de
        // opciones de ordenamiento

        // Paso 2: Orden interno
        switch (this.monitorOrder.value.Id) {
          case this.mercadoKey:
            // comparamos segun el orden superior y si son iguales, por fecha.
            return a.Superior === b.Superior ? compare(a.FechaRaw, b.FechaRaw, this.monitorOrderDirection.value) :
              compare(a.Superior, b.Superior, this.monitorOrderDirection.value);
          case this.productoKey:
            return this.altProdOrder ?
              // alfabeticamente
              compare(a.Superior, b.Superior, this.monitorOrderDirection.value) :
              // por score
              compare(getProductoScore(a.Superior), getProductoScore(b.Superior), this.monitorOrderDirection.value);
          case this.monedaKey:
            // comparamos segun la moneda y si son iguales, por fecha
            return a.Moneda === b.Moneda ? compare(a.FechaRaw, b.FechaRaw, this.monitorOrderDirection.value)
              : compare(a.Moneda, b.Moneda, this.monitorOrderDirection.value);
          case this.publicacionKey:
            // nos aseguramos de comparar las fechas en UNIX para evitar comparar strings
            return compare(a.FechaRaw, b.FechaRaw, this.monitorOrderDirection.value);
        }
        return 0;
      });

      this.monitorGenericoPrecios = [];
      this.monitorGenericoPrecios = precios.slice();
    } else {
      this.monitorGenericoPrecios = [];
    }
  }

  monitorOrderChange(grupo: boolean): void {
    // revisamos si el ordenamiento es productos, de ser asi, pasamos al modo alternativo
    // donde ordenamos los productos alfabeticamente y no por score

    if (grupo) {
      this.altProdOrder = this.monitorGroup.value.Id.Id === this.productoKey;
      this.monitorGroupDirection.setValue(!this.monitorGroupDirection.value);
    } else {
      this.altProdOrder = this.monitorOrder.value === this.productoKey;
      this.monitorOrderDirection.setValue(!this.monitorOrderDirection.value);
    }
    this.orderPreciosMonitor();
  }

  parsePizarraGenericPrecio(precio): PrecioGenericViewModel {
    return {
      FechaCreacion: precio.Fecha,
      FechaPublicacion: precio.FechaPublicacion,
      Id: precio.Id,
      Mercado: precio.Mercado,
      Moneda: precio.Moneda,
      Precio: precio.Precio,
      Producto: precio.Producto,
      Usuario: precio.UsuarioCreador,
      Validador: precio.UsuarioValidador,
      Varianza: precio.Varianza
    }
  }

  public printPrecios() {
    this.dialogsService.imprimirPreciosPNG('Pizarras', moment().toDate(),this.monitorGenericoPrecios);
  }

  get monitorGroup(): AbstractControl {return this.monitorForm.get('agrupar')}
  get monitorGroupDirection(): AbstractControl {return this.monitorForm.get('agruparDirection')}
  get monitorOrder(): AbstractControl {return this.monitorForm.get('ordenar')}
  get monitorOrderDirection(): AbstractControl {return this.monitorForm.get('ordenarDirection')}

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/precios-seccion/precios-pizarra/precios-pizarra.component.ts